import { axiosInstance } from "./instance";

export const putConsent = (data) => {
  return axiosInstance.post(`/contract/consent-under-age`, data);
};

export const getMember = (uuid) => {
  return axiosInstance.get(`/invoice/uuid/${uuid}`);
};
